import { Link, useLocation } from "react-router";
import { useRail } from "../../../shared/phone/media";
import { usePartnerAuth } from "../../context/PartnerAuthContext";
import { initialsOf } from "../../lib/format";
import { PortalMark } from "../Logo";
import { Icon } from "./Icon";
import { PLACES } from "./TabBar";

/**
 * The rail down the left of an iPad: each place with its name under its icon, and the partner's photo at the
 * foot, which opens Account. Shown only at the rail's widths.
 */
export function Rail() {
  const rail = useRail();
  const { pathname } = useLocation();
  const { session } = usePartnerAuth();
  if (!rail) return null;
  const partner = session?.partner ?? null;
  const lit = (to: string) => pathname === to || pathname.startsWith(`${to}/`);

  return (
    <nav className="pn-rail" aria-label="Main">
      <Link className="pn-rail-mark" to="/home" aria-label="Home">
        <PortalMark className="plogo po-mark" />
      </Link>
      {PLACES.map(({ to, label, icon }) => (
        <Link key={to} to={to} className={lit(to) ? "pn-rail-item on" : "pn-rail-item"} aria-current={lit(to) ? "page" : undefined}>
          <Icon name={icon} />
          <span>{label}</span>
        </Link>
      ))}
      <span className="pn-rail-grow" />
      <Link to="/profile" className={lit("/profile") ? "pn-rail-me on" : "pn-rail-me"} aria-label="Your account">
        {partner?.avatarUrl ? <img src={partner.avatarUrl} alt="" /> : initialsOf(`${partner?.firstName ?? ""} ${partner?.lastName ?? ""}`.trim() || "P")}
      </Link>
    </nav>
  );
}
